import { render, staticRenderFns } from "./DADatatable.vue?vue&type=template&id=b0c5b4ea&scoped=true"
import script from "./DADatatable.vue?vue&type=script&lang=js"
export * from "./DADatatable.vue?vue&type=script&lang=js"
import style0 from "./DADatatable.vue?vue&type=style&index=0&id=b0c5b4ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c5b4ea",
  null
  
)

export default component.exports